import type { ListAndImageProps as Props } from './types';
import { withChildren } from '@builder.io/react';
import { useColorProvider } from '@/utils/ColorProvider';
import { TextAlignmentOptions, HeroImagePlacements } from '@/constants';
import RichText from '@/components/RichText';
import { cls } from '@/utils/cls';
import style from './ListAndImage.module.scss';
export function ListAndImage({
  extendStyles,
  heading,
  headingAlignment = TextAlignmentOptions.LEFT,
  items,
  image,
  color,
  line,
  children,
  textSide = HeroImagePlacements.LEFT,
  mobileImage = true,
  headingSpan = false
}: Props) {
  const _className = cls(style.root, extendStyles);
  const {
    colors
  } = useColorProvider();
  const textLeft = textSide === TextAlignmentOptions.LEFT;
  const textStyles = cls(style.text, textLeft ? style.left : style.right);
  const imageStyles = cls(style.wrapper, textLeft ? style.right : style.left, headingSpan ? style.square : '');
  const wrapperStyles = cls(style.mobileWrapper, !mobileImage ? style.mobileHide : '', headingSpan ? style.square : '');
  return <section className={_className} style={{
    backgroundColor: color || '#F9FAFB'
  }} data-sentry-component="ListAndImage" data-sentry-source-file="ListAndImage.tsx">
			<div className={style.content} data-grid>
				{heading && headingSpan && <RichText text={heading} className={cls(style.heading, !!line ? style.hr : '')} style={{
        borderColor: colors.secondaryAccentColor
      }} data-align={headingAlignment} />}
				<div className={textStyles}>
					{image && <div className={wrapperStyles}>
							<img src={image} alt="" role="presentation" />
						</div>}
					{heading && !headingSpan && <RichText text={heading} className={!!line ? style.hr : ''} style={{
          borderColor: colors.secondaryAccentColor
        }} data-align={headingAlignment} />}
					<div className={style.list}>
						{items.map((item, index) => <div key={index} className={style.listItem}>
								{item.icon && <img src={item.icon} alt="" role="presentation" className={style.icon} />}
								<div className={style.itemContent}>
									<h3 className={style.itemHeading}>{item.heading}</h3>
									{item.subheading && <p className={style.itemSubheading}>{item.subheading}</p>}
								</div>
							</div>)}
					</div>
					{children}
				</div>

				{image && <div className={imageStyles}>
						<img src={image} alt="" role="presentation" />
					</div>}
			</div>
		</section>;
}
export default withChildren(ListAndImage);